import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatExchangeName',
})
export class FormatExchangeNamePipe implements PipeTransform {
  transform(exchangeName: string): string {
    return exchangeName === 'KyrrexDirect' ? 'Kyrrex' : exchangeName;
  }
}
